<template>
  <div class="layout">
      <div class="layout-bro"  >
      <div class="layout-bro-item" >
        <div >
      <br />

      <div style="font-size: 25px; text-align: center" >
        {{msg?'新增：'+msg:'修改字段' }}
      </div>
      <br />

      <label   class="weui-cell" v-if="fdtemp.hasOwnProperty('name')" >
        
        <div class="weui-cell__hd">
          <label class="weui-label">字段名称</label>
        </div>
        <div class="weui-cell__bd">
          <input
          
          class="weui-input"
               v-model="fdtemp.name"
            placeholder="填写字段名称"
          />
        </div>             
      </label>

      <div class="weui-cell" v-if="fdtemp.hasOwnProperty('ismust')">
        <div class="weui-cell__hd">
          <label class="weui-label">是否必填</label>
        </div>
        <div class="weui-cell__bd">           
          <van-radio-group v-model="fdtemp.ismust" direction="horizontal" class="radiocss">         
            <van-radio name="1" checked-color="#07c160">是</van-radio>
            <van-radio name="" checked-color="#07c160">否</van-radio> 
          </van-radio-group>          
        </div>
      </div>

      <div v-if="fdtemp.hasOwnProperty('pickerdata')">
   
        <div  class="weui-cell">
          请选择选项数量：<van-stepper v-model="pickernum" />
        </div>
        <br>
        <label v-for="v in pickernum" class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">选项内容</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
             v-model="pickerdata[v-1]"
              placeholder="内容'"
              
            />
          </div>
        </label>
        
      </div>
   
      <div v-if="fdtemp.hasOwnProperty('rows')">
        <div class="weui-cell">
        
         请选择文本框行数：<van-stepper v-model="fdtemp.rows" />
       
      </div>
      </div>



      <div v-if="fdtemp.hasOwnProperty('boxdata')">
        <div class="weui-cell">
    
         请选择选项数量：<van-stepper v-model="value" />
       
      </div>
      <br>
          <label  class="weui-cell" v-if="fdtemp.hasOwnProperty('boxdata')"  v-for="v in value">
            <div class="weui-cell__hd">
              <label class="weui-label">选项{{v}}内容</label>
            </div>
            <label class="weui-cell__bd">
              <input
                class="weui-input"
                v-model="fdtemp.boxdata[v-1]"
                :placeholder="'填写选项'+v+'内容'"
               
              />
            </label>
          </label>
        
      </div>

        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('content')">
            <div class="weui-cell__bd">
                <textarea class="weui-textarea" 
                v-model="textcontent"
                 placeholder="请输入文字提示" 
                 rows="3"
                 :style = "{'color':fdtemp.color,'textAlign':fdtemp.textalign,'fontSize':fdtemp.fontsize}"
                style="user-select: text;"
                 ></textarea>
             </div>
             
        </div>
   
        
        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('type')">
          <div class="weui-cell__hd">
            <label class="weui-label">字段类型</label>
          </div>
          <div class="weui-cell__bd">           
            <van-radio-group v-model="fdtemp.type" direction="horizontal" class="radiocss">         
              <van-radio name="" checked-color="#07c160">普通</van-radio>
              <van-radio name="tel" checked-color="#07c160">手机号</van-radio> 
              <van-radio name="email" checked-color="#07c160">邮箱</van-radio> 
            </van-radio-group>          
          </div>
        </div>


        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('maxnum')">
          <div class="weui-cell__hd">
            <label class="weui-label">上传数量</label>
          </div>
          <div class="weui-cell__bd">           
            <van-radio-group v-model="fdtemp.maxnum" direction="horizontal" class="radiocss">         
              <van-radio name="1" checked-color="#07c160">1</van-radio>
              <van-radio name="2" checked-color="#07c160">2</van-radio> 
              <van-radio name="3" checked-color="#07c160">3</van-radio> 
            </van-radio-group>          
          </div>
        </div>



        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('color')">
          <div class="weui-cell__hd">
            <label class="weui-label">字体颜色</label>
          </div>
          <div class="weui-cell__bd">           
            <van-radio-group v-model="fdtemp.color" direction="horizontal" class="radiocss">         
              <van-radio name="" checked-color="black">黑色</van-radio>
              <van-radio name="red" checked-color="red">红色</van-radio> 
              <van-radio name="yellow" checked-color="yellow">黄色</van-radio> 
              <van-radio name="green" checked-color="green">绿色</van-radio> 
              <van-radio name="blue" checked-color="blue">蓝色</van-radio> 
            </van-radio-group>          
          </div>
        </div>

        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('textalign')">
          <div class="weui-cell__hd">
            <label class="weui-label">对齐方式</label>
          </div>
          <div class="weui-cell__bd">           
            <van-radio-group v-model="fdtemp.textalign" direction="horizontal" class="radiocss">         
              <van-radio name="left" checked-color="#07c160">左对齐</van-radio>
              <van-radio name="center" checked-color="#07c160">居中对齐</van-radio> 
              <van-radio name="right" checked-color="#07c160">右对齐</van-radio> 
            </van-radio-group>          
          </div>
        </div>

        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('fontsize')">
          <div class="weui-cell__hd">
            <label class="weui-label">字体大小</label>
          </div>
          <div class="weui-cell__bd">           
            <van-radio-group v-model="fdtemp.fontsize" direction="horizontal" class="radiocss">         
              <van-radio name="14px" checked-color="#07c160">14px</van-radio>
              <van-radio name="16px" checked-color="#07c160">16px</van-radio> 
              <van-radio name="18px" checked-color="#07c160">18px</van-radio> 
              <van-radio name="20px" checked-color="#07c160">20px</van-radio> 
              <van-radio name="22px" checked-color="#07c160">22px</van-radio> 
              <van-radio name="24px" checked-color="#07c160">24px</van-radio>
            </van-radio-group>          
          </div>
        </div>



        <div v-if="fdtemp.hasOwnProperty('datefrom')">
            <label  class="weui-cell" v-if="fdtemp.hasOwnProperty('datefrom')" >
              <div class="weui-cell__hd">
                <label class="weui-label">开始年份</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  placeholder="请填写开始年份"
                  v-model="fdtemp.datefrom"
                />
              </div>
            </label>          
        </div>

        <div class="weui-cell" v-if="fdtemp.hasOwnProperty('depth')">

          <div class="weui-cell__bd">           
            <van-radio-group v-model="fdtemp.depth" direction="horizontal" class="radiocss" style="width:100%;display: felx; justify-content: space-around;">         
              <van-radio name="4" checked-color="#07c160">省市区县</van-radio>
              <van-radio name="3" checked-color="#07c160">省市区</van-radio> 
              <van-radio name="2" checked-color="#07c160">省市</van-radio> 
              <van-radio name="1" checked-color="#07c160">省</van-radio> 
            </van-radio-group>          
          </div>
        </div>


        <div v-if="fdtemp.hasOwnProperty('dateto')">
          <label  class="weui-cell" v-if="fdtemp.hasOwnProperty('dateto')" >
            <div class="weui-cell__hd">
              <label class="weui-label">结束年份</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                placeholder="请填写结束年份"
                v-model="fdtemp.dateto"
              />
            </div>
          </label>          
      </div>
      <div v-if="fdtemp.hasOwnProperty('src')">
        <Uploader :tb="src">

        </Uploader>
      </div>




      <br />
      <a href="javascript:" @click="insertbd" class="weui-btn weui-btn_primary"
        >{{msg?'确定新增':'确认修改'}}</a
      >
      <a v-if="msg"
        href="javascript:"
        @click="$emit('guan')"
        class="weui-btn weui-btn_primary"
        >取消操作</a
      >
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
    </div>
    </div>
  </div>
  

</template>


<script>
  import Uploader from '@/fields/Uploader.vue'
  import Vue from 'vue';
import { Stepper } from 'vant';
Vue.use(Stepper);
export default {
    props:['msg',"fdtemp","bd"],
    components:{
      Uploader
    },
    data(){
        return{
          value: 1,
          textcontent:'',
          pickernum:1,
          pickerdata:[],
          src:{
						name: '装饰图片',
						val: '',
						ismust: '1',
						zj: 'Uploader',
						maxnum:'1'
					}
        }
    },
    created(){
      if(this.fdtemp.boxdata&&this.fdtemp.boxdata.length!==0){
        this.value = this.fdtemp.boxdata.length
      }
      if(this.fdtemp.pickerdata&&this.fdtemp.pickerdata.length!==0){
         
        this.fdtemp.pickerdata.forEach(item=>{
          this.pickerdata.push(item['label']);
          
        });
        this.pickernum = this.pickerdata.length;
      }
      if(this.fdtemp.content){
        this.textcontent = this.fdtemp.content;
      }
    },
    methods:{

			insertbd(){	
        if(!this.msg){
          if(this.fdtemp.boxdata){
            let arr = this.fdtemp.boxdata.filter(item=>{
              if(item){
                return true
              }
            })
            this.fdtemp.boxdata = arr;
          }
          if(this.fdtemp.pickerdata){
            let arr = [];
            this.pickerdata.forEach(item=>{
              let obj = {}
              obj['label'] = item;
              arr.push(obj);
            });
            this.fdtemp.pickerdata = arr;
          }
          if(this.fdtemp.src&&this.src.val){
            this.fdtemp.src =  'data:image/jpeg;base64,'+this.src.val[0]['data'];
          }

      return this.$emit("guan")

        }

        
        if(this.fdtemp.boxdata){
          let arr =  this.fdtemp.boxdata.filter(item=>{
          if(item){
            return true;
          }
          
        })
        this.fdtemp.boxdata = arr;   
        }
        if(this.fdtemp.pickerdata){
          let arr = [];
          this.pickerdata.forEach(item=>{
            if(item){
              let obj = {};
              obj['label'] = item;
              arr.push(obj);
            }
          })
          this.fdtemp.pickerdata = arr;
        }
        if(this.src.val){
            
          this.fdtemp.src = 'data:image/jpeg;base64,'+this.src.val[0]['data'];
    
          
          }

				let obj = {}
				for(let item in this.fdtemp){
					obj[item] = this.fdtemp[item]
        }        
				this.bd.push(obj);
        this.$emit('fdtemp')
        this.$emit("guan")

			},
    },
    watch:{
      value(news,olds){
        if(news<olds){
          this.fdtemp.boxdata.length = news;
        }
     
      },
      pickernum(news,olds){
        if(news<olds){
          this.pickerdata.length = news;
        }
      },
      textcontent(n,o){

        let str = '';
          for(let x in this.textcontent){
          if(this.textcontent[x]=='\n'){
            str+='<br>';
          }else if(this.textcontent[x]==' '){
            str+='&nbsp;'
          }else{
           str+=this.textcontent[x];
          }
        }
      
        this.fdtemp.content=str;
        
      }
    }     
};
</script>


<style lang = 'less'>
  .radiocss{
    display:flex;  

  }
	.layout{
		position: fixed;
		top:0;
		height: 100%;
		width: 100%;
		min-width: 320px;
		max-width: 540px;
			z-index: 100;
		.layout-bro{
			position: absolute;
			overflow-y: scroll;
			background-color: #dddddd;
			width: 100%;
			height: 100%;
			top:0;
      z-index: 4;
      display:flex;
      justify-content: center;
      .layout-bro-item{
      
        width:95%;
      }
		}
			}
</style>


// WEBPACK FOOTER //
// src/manage/addfield/Addfield.vue